import {useEffect, useState} from "react";
import auth from "../../../../../../utils/authentication";
import {TitlePage} from "../../../../../shared";
import ProfileLogsView from "../../../profileLogsView/profileLogsView";
import {SquadflixLogsApi} from "../../../../../../apis/squadflix-logs/SquadflixLogsApi";

const MyLogsView = () => {


    const [tmdbItems, setTmdbItems] = useState([]);
    const [userViewRecord, setUserViewRecord] = useState({});
    const [loadingViewRecord, setLoadingViewRecord] = useState(true);
    useEffect(() => {
        SquadflixLogsApi.getMyViewingLogs({}).then(res => {
            setTmdbItems(res.tmdbItems);
            setUserViewRecord(res.usersMap[auth.currentUser.uid] ?? {});
            setLoadingViewRecord(false);
        })
    }, [])

    return (
        <div>
            <TitlePage icon="fa-solid fa-clock-rotate-left" className="mb-2" fixedHeight="27px"
                       title={<span>Tu historial de visualización</span>}
                       leftClass="col-12" hideSeparator/>
            <ProfileLogsView tmdbItems={tmdbItems}
                             userViewRecord={userViewRecord}
                             loading={loadingViewRecord}/>
        </div>
    )

}

export default MyLogsView;
